export default "__VITE_ASSET__B96Y4moh__"